export type Entry<T extends object> = { [K in keyof T]-?: [K, T[K]] }[keyof T];

export const entries = <T extends object>(obj: T) => Object.entries(obj) as Entry<T>[];
